import React from "react";
import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

const projectVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

const Project = ({ title, description, image }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;

  return (
    <motion.div variants={projectVariant} className="relative max-w-[400px] max-h-[400px] m-3">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{title}</p>
        <p className="mt-7">{description}</p>
      </div>
      <img src={image} alt={title} className="object-cover w-full h-full" />
    </motion.div>
  );
};

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "Gastromi",
      description: "A Django-powered job board for gastronomy professionals.",
      image: "/assets/gastromi_code.JPG",
    },
    {
      id: 2,
      title: "Stock Management app",
      description: "A python and Django stock management application...",
      image: "/assets/project-4.jpeg",
    },
    {
      id: 3,
      title: "PyShop",
      description: "A retail shop using Python",
      image: "/assets/project-1.jpeg",
    },
    {
      id: 4,
      title: "Financial Dashboard",
      description: "A financial dashboard with charts and graphs.",
      image: "/assets/project-7.jpeg",
    },
  ];

  return (
    <section id="projects" className="pt-48 pb-48">
      <motion.div
        className="md:w-2/5 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{ hidden: { opacity: 0, y: -50 }, visible: { opacity: 1, y: 0 } }}
      >
        <div>
          <p className="font-playfair font-semibold text-4xl">
            <span className="text-red">PRO</span>JECTS
          </p>
          <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
          </div>
        </div>
        <p className="mt-10 mb-10">
          A showcase of my development projects — powered by Django & React.
        </p>
      </motion.div>

      <div className="flex justify-center">
        <motion.div className="sm:grid sm:grid-cols-3 gap-5" variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          {projects.length > 0 ? (
            projects.map((project) => (
              <Project key={project.id} title={project.title} description={project.description} image={project.image} />
            ))
          ) : (
            <p className="text-center text-gray-500">No projects found.</p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
